// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay__overlay--2IF"};